import './paginate.css'
import ReactPaginate from 'react-paginate';
import { Chevron } from "./Chevron.component";
import { useEffect, useState } from 'react';
import { Input } from '../input/input';

export const Paginate = (props) => {

    const [currentPage, setCurrentPage] = useState(0);
    const [size, setSize] = useState(props.quantity ? props.quantity : Math.ceil(window.innerHeight / (90 - Math.log(window.innerHeight / 90 + 1))));
    const pageCount = Math.ceil(props.arr.length / size);
    const handlePageClick = ({ selected }) => {
        setCurrentPage(selected);
    };

    const handleResize = () => {
        setSize(Math.ceil(window.innerHeight / (90 - Math.log(window.innerHeight / 90 + 1))))
    };

    useEffect(() => {
        if (!props.quantity) {
            window.addEventListener('resize', handleResize);

            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }
    }, []);

    const handleInputChange = (e) => {
        const selectedPage = parseInt(e.target.value, 10) - 1;
        if (selectedPage >= 0 && selectedPage < pageCount) {
            setCurrentPage(selectedPage);
        }
    };

    useEffect(() => {
        if (props.arr) {
            const offset = currentPage * size;
            props.set(props.arr.slice(offset, offset + size))
        }
    }, [currentPage, props.arr, size])

    return (
        <div className="input-component-paginated-content">
            <ReactPaginate
                previousLabel={<Chevron className={`chevron-pagination ${currentPage === 0 ? 'blocked-chevron' : ''}`} />}
                nextLabel={<Chevron />}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={1}
                onPageChange={handlePageClick}
                containerClassName={`${props.className} pagination`}
                activeClassName={'active'}
                forcePage={currentPage}
            />
            {/* {<div className="input-component-paginated">
                <h3>{props.title ? props.title : 'Page'}</h3>
                <Input onChange={handleInputChange} type='number' style={{ width: 40 }} props={{ height: 25, background: 'var(--tab-background)' }} />
            </div>} */}
        </div>
    )
}